import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import EventMainPreview from "../../../Components/EventMainPreview";

export default function Day({ day }) {
  const momentToday = (time) => {
    const momentTime = moment(time);
    return moment(day)
      .set("hour", momentTime.hour())
      .set("minute", momentTime.minute());
  };
  const todayEvents = useSelector((state) =>
    state.tasks
      .filter(
        (t) =>
          !t.complete &&
          t.time &&
          t.time.start &&
          t.time.end &&
          moment(t.date).isSame(moment(day), "date")
      )
      .map((t) => ({
        ...t,
        location: "",
        startTime: moment(t.time.start, "HH:mm"),
        endTime: moment(t.time.end, "HH:mm"),
        isEvent: true,
      }))
  );
  const events = useSelector((state) =>
    [
      ...state.calendar.events
        .filter((e) => e.days[moment(day).day()])
        .map((e) => ({
          ...e,
          startTime: momentToday(e.startTime),
          endTime: momentToday(e.endTime),
          isEvent: false,
        })),
      ...todayEvents,
    ].sort((a, b) => a.startTime.valueOf() - b.startTime.valueOf())
  );
  return (
    <div style={{ width: `${100 / 7}%`, display: "flex", flexFlow: "column" }}>
      {events.map((e) => (
        <EventMainPreview event={e} onClick={() => {}} />
      ))}
    </div>
  );
}
